module.exports = __webpack_public_path__ + "static/media/bg_rectangle-dark-2.751a3f44.jpg";